"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

CloseIcon.defaultProps = _defineProperty({
  focusable: "false",
  'aria-hidden': "true",
  fill: "#666",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, "focusable", 'false');

var CloseButton = function CloseButton(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn uxf-btn-icon",
    onClick: onClick,
    "aria-label": label
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null));
};

exports.CloseButton = CloseButton;
CloseButton.propTypes = {
  /**
   * Aria-label for close icon since icon has no text associated with it.
   */
  label: _propTypes["default"].string.isRequired,

  /**
   * Function associated with 'click' of close icon
   */
  onClick: _propTypes["default"].func
};
CloseButton.defaultProps = {
  label: 'Close'
};